<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane">
                <div class="info_cont">
                    <span v-show="IsEnabled" class="btnTovabb" @click="RedirToMedicall">átirányítás az időpontfoglalásra<i class="fas fa-angle-double-right" style="margin-left:10px;"></i></span>
                    <span v-show="IsEnabled==false">a hívás azonosító érvénytelen</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmMedicall_Redir',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmMedicall",
            IsEnabled:true,
            SzakteruletID:0,
            SzolgaltatasID:0,
            IntezmenyIDS:"",
            PMS:"",
            LinkUrl:"",
      }
  },
  model: {
  },  
  methods:{

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmMedicall", pCompName);
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },


    SetLang()
    {
        this.Init();
    },

    async RedirToMedicall()
    {
        this.scrollToTop();

        if (this.LinkUrl == "") { return; }

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = this.LinkUrl;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "SzakteruletID");
        myInput.setAttribute("id", "SzakteruletID");
        myInput.setAttribute("value", this.SzakteruletID);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "SzolgaltatasID");
        myInput.setAttribute("id", "SzolgaltatasID");
        myInput.setAttribute("value", this.SzolgaltatasID);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "IntezmenyIDS");
        myInput.setAttribute("id", "IntezmenyIDS");
        myInput.setAttribute("value", this.IntezmenyIDS);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PMS");
        myInput.setAttribute("id", "PMS");
        myInput.setAttribute("value", this.PMS);
        myForm.appendChild(myInput);

        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        

    },


    async Init()
    {
        var PMS = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "mcredir") && (GRCAPP_GetParameters.PMS != "") && (GRCAPP_GetParameters.PMS != undefined))
        {
            PMS = GRCAPP_GetParameters.PMS;
            GRCAPP_GetParameters.PMS = "";
        }

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sPMS:PMS,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Redir_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.IsEnabled = false;

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        if (Q.RESULT[0].LinkUrl == "")
        {
            this.$refs.GRCDB.HideLoading();
            this.IsEnabled = false;
            return;
        }

        this.SzakteruletID = Q.RESULT[0].SzakteruletID;
        this.SzolgaltatasID = Q.RESULT[0].SzolgaltatasID;
        this.IntezmenyIDS = Q.RESULT[0].IntezmenyIDS;
        this.PMS = PMS;
        this.LinkUrl = Q.RESULT[0].LinkUrl;
        
        this.$refs.GRCDB.HideLoading();

        this.RedirToMedicall();

    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.info_cont
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: center;
    padding: 30px 4px;
    color: var(--premblue);
}


.btnTovabb
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btnTovabb:hover
{
  background-color: var(--premgreen);
  color:#fff;
}



</style>